import { render, staticRenderFns } from "./rule-action-item.vue?vue&type=template&id=04ee69f4&scoped=true&"
import script from "./rule-action-item.vue?vue&type=script&lang=ts&"
export * from "./rule-action-item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ee69f4",
  null
  
)

export default component.exports